export default __webpack_public_path__ + "static/media/open-sans-latin-700.f24f4bce.woff";